import React, { useState } from 'react'
import { Button, CircularProgress } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'
import { useAppToast } from '@ui-seeker/app'
import { postSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '../../@constants/routes'
import { filtersValue } from './@signals'

export default function ExportButton() {
    const [isExporting, setIsExporting] = useState(false)
    const { showToast } = useAppToast()

    const handleExport = async () => {
        setIsExporting(true)

        try {
            const filters = filtersValue.value
            // Remove pagination for export
            const exportFilters = { ...filters }
            delete exportFilters.page
            delete exportFilters.pageSize

            // Remove undefined values
            const cleanFilters = Object.fromEntries(
                Object.entries(exportFilters).filter(([_, v]) => v !== undefined)
            )

            const response = await fetch(`${BACKEND_APIS.AUDIT_LOG}/export`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(cleanFilters),
                credentials: 'include'
            })

            if (!response.ok) {
                throw new Error('Export failed')
            }

            // Get filename from Content-Disposition header or generate one
            const contentDisposition = response.headers.get('Content-Disposition')
            let filename = `audit_log_${new Date().toISOString().slice(0, 19).replace(/[:-]/g, '')}.csv`
            if (contentDisposition) {
                const match = contentDisposition.match(/filename=(.+)/)
                if (match) filename = match[1]
            }

            // Download the file
            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = filename
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            window.URL.revokeObjectURL(url)

            showToast.success('Export completed')
        } catch (error) {
            console.error('Export error:', error)
            showToast.error('Failed to export audit log')
        } finally {
            setIsExporting(false)
        }
    }

    return (
        <Button
            variant="outlined"
            size="small"
            onClick={handleExport}
            disabled={isExporting}
            startIcon={isExporting ? <CircularProgress size={16} /> : <IconSeeker icon="download" size="sm" />}
        >
            Export CSV
        </Button>
    )
}
